angular.module('main').directive('snCheckbox', () => ({
	restrict: 'AE',
	template:
		'<div class="checkbox-squared">' +
		'<input type="checkbox" id="{{id}}" ng-model="drModel"/>' +
		'<label for="{{id}}"></label>' +
		'</div>',
	scope: {
		drModel: '=snModel',
		id: '@snId'
	},
	replace: true,
	transclude: true,
	link(scope, elem, attr, ctrl) {}
}));



// WEBPACK FOOTER //
// ./web/js/components/Elements/snCheckbox.js